<div
  class="relative flex h-14 w-14 items-center justify-center rounded-2xl"
  [ngClass]="documentIconColor()"
>
  @switch (documentType()) {
    @case (medicalDocumentType.Appointment) {
      <img
        class="h-full w-full object-contain"
        alt="Appointment document"
        width="53"
        height="53"
        [ngSrc]="'assets/icons/ic_documentType_appointment.svg'"
      />
    }
    @case (medicalDocumentType.LaboratoryService) {
      <img
        class="h-full w-full object-contain"
        alt="Laboratory service document"
        width="53"
        height="53"
        [ngSrc]="'assets/icons/ic_documentType_laboratory.svg'"
      />
    }
    @case (medicalDocumentType.PersonalDoctorAppointment) {
      <img
        class="h-full w-full object-contain"
        alt="Personal doctor appointment document"
        width="53"
        height="53"
        [ngSrc]="'assets/icons/ic_documentType_appointment.svg'"
      />
    }
    <!--    TODO: uncomment when Vaccination will added as one of possible medical document-->
    <!--    @case (medicalDocumentType.Drugs) {-->
    <!--      <img-->
    <!--        class="h-full w-full object-contain"-->
    <!--        alt="Drugs document"-->
    <!--        width="53"-->
    <!--        height="53"-->
    <!--        [ngSrc]="'assets/icons/ic_documentType_vaccine.svg'"-->
    <!--      />-->
    <!--    }-->
    @case (medicalDocumentType.InstrumentalDiagnostic) {
      <img
        class="h-full w-full object-contain"
        alt="Instrumental diagnostic document"
        width="53"
        height="53"
        [ngSrc]="'assets/icons/ic_documentType_diagnostics.svg'"
      />
    }
    @default {
      <img
        class="h-full w-full object-contain"
        alt="Other document"
        width="53"
        height="53"
        [ngSrc]="'assets/icons/ic_documentType_other.svg'"
      />
    }
  }
  @if (!!processingStatus() && processingStatus() !== documentProcessingStatus.Done) {
    <div
      class="absolute -right-[0.5rem] bottom-0 flex h-5 w-5 rounded-2xl bg-neutral-0 p-0.5 text-neutral-500"
      [ngClass]="{ 'text-error-600': processingStatus() === 'Warning' }"
    >
      <mat-icon
        style="--ms-opsz: 16; font-size: 16px"
      >{{ documentSyncStatusIcon() }}</mat-icon>
    </div>
  }
</div>
